import { RootMasterMessageHub } from '../../master';
import CustomSourceKey, { isCustomSourceKey } from './key';
import initNewOrderDetailPollerSource from './newOrderDetailPoller';

/** 初始化自定义消息源 */
const initCustomSource = (instance: RootMasterMessageHub<any, CustomSourceKey>) => {
    initNewOrderDetailPollerSource(instance);
};

export { CustomSourceKey, isCustomSourceKey, initCustomSource };
